var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      directives: [{ name: "tooltip", rawName: "v-tooltip" }],
      ref: "addToWishList",
      staticClass: "product-detail-wishlist",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "top",
        title: _vm.tooltipText,
      },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.switchState()
        },
      },
    },
    [
      _c(
        "svg",
        {
          staticClass: "product-detail-wishlist__svg",
          attrs: { xmlns: "http://www.w3.org/2000/svg" },
        },
        [
          _c("use", {
            attrs: {
              "xmlns:xlink": "http://www.w3.org/1999/xlink",
              "xlink:href": "#svg-wishlist",
            },
          }),
        ]
      ),
      _vm._v(
        "\n  " + _vm._s(_vm.$translate("Ceres::Template.wishList")) + "\n"
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }